import gql from 'graphql-tag';

export const GetVendorListV2 = gql`
  query GetVendorListV2 {
    getVendorListV2 {
      id
      primary_contact_id
      company_name
      parent_company_name
      year_of_incorporation
      website
      status
      onboarded_date
      coi_expiration_date
      w9_expiration_date
      primary_contact {
        email_id
        phone_number {
          primary
        }
        first_name
        last_name
      }
      vendor_team {
        id
        first_name
        last_name
        email_id
        user_role_id
        vendor_role
        phone_number {
          primary
          secondary
        }
        system_access
        is_account_manager
        status
      }
      vendor_job_categories {
        id
      }
      vendor_type {
        id
        name
      }
      eligible_marketplace
      skip_approval_marketplace_candidate
      company_types {
        id
        name
      }
      vendor_workspaces {
        id
        workspace_id
      }
    }
  }
`;

export const GetVendorForProfile = gql`
  query getVendorForProfile($vendorId: ID!) {
    getVendor(vendor_id: $vendorId) {
      id
      status
      primary_contact_id
      vendor_team {
        id
        first_name
        last_name
        email_id
        user_role_id
        vendor_role
        phone_number {
          primary
          secondary
        }
        system_access
        is_account_manager
        status
      }
      vendor_job_categories {
        id
        name
      }
      vendor_locations {
        id
        address_type
        city
        state
        street_address
        zip_code
        phone_number
      }
      vendor_payments {
        id
        city
        state
        street_address
        zip_code
        phone_number
      }
      vendor_type {
        id
        name
      }
    }
  }
`;

export const GetVendorForProfileCard = gql`
  query getVendorForProfileCard($vendorId: ID!) {
    getVendor(vendor_id: $vendorId) {
      id
      primary_contact_id
      company_name
      parent_company_name
      website
      year_of_incorporation
      status
      onboarded_date
      message
      company_types {
        id
        name
      }
      vendor_type {
        id
        name
      }
      vendor_documents {
        id
        filename
        url
        document_category {
          id
          name
        }
        status
        date
      }
      vendor_locations {
        id
        address_type
        city
        state
        street_address
        zip_code
        phone_number
      }
      vendor_team {
        id
        first_name
        last_name
        email_id
        user_role_id
        vendor_role
        phone_number {
          primary
          secondary
        }
        system_access
        is_account_manager
        created_on
      }
      skip_approval_marketplace_candidate
      electronic_payment_file_url
      company_logo_document_category_id
    }
  }
`;

export const GetVendorIdForUser = gql`
  query getVendorForUser {
    getVendorForUser {
      id
    }
  }
`;

export const GetVendorDocuments = gql`
  query getVendorDocuments($vendorId: ID!) {
    getVendor(vendor_id: $vendorId) {
      id
      vendor_documents {
        id
        filename
        url
        document_category {
          id
          name
        }
        status
        date
        effective_date
        expiration_date
      }
    }
  }
`;

// export const getOnboardingJobCategories = gql`
//   query getOnboardingJobCategories($vendor_id: ID!, $verification_code: String) {
//     getOnboardingJobCategories(vendor_id: $vendor_id, verification_code: $verification_code) {
//       id
//       name
//       description
//     }
//   }
// `;

export const getVendorDocumentCategory = gql`
  query getVendorDocumentCategory {
    getVendorDocumentCategory {
      id
      name
      description
    }
  }
`;

export const getVendorDocumentCategoryPublic = gql`
  query getVendorDocumentCategoryPublic($vendor_id: ID!, $verification_code: String) {
    getVendorDocumentCategoryPublic(vendor_id: $vendor_id, verification_code: $verification_code) {
      id
      name
      description
    }
  }
`;

export const GetVendorPublic = gql`
  query GetVendorPublic($vendor_id: ID!, $verification_code: String) {
    getVendorPublic(vendor_id: $vendor_id, verification_code: $verification_code) {
      id
      parent_company_name
      website
      year_of_incorporation
      vendor_type {
        id
        name
        description
      }
      company_name
      company_types {
        id
        name
      }
      vendor_team {
        id
        user_role_id
        first_name
        last_name
        phone_number {
          primary
          secondary
        }
        email_id
        vendor_role
        is_account_manager
        status
        system_access
      }
      vendor_documents {
        id
        filename
        url
        date
        document_category {
          id
          name
          description
        }
        status
      }
      vendor_locations {
        id
        address_type
        city
        state
        street_address
        zip_code
        phone_number
      }
      vendor_payments {
        id
        city
        state
        street_address
        zip_code
        phone_number
      }
    }
  }
`;

export const GetVendorType = gql`
  query GetVendorType {
    getVendorType {
      id
      name
      description
    }
  }
`;

export const GetVendorTeamMemberByEmailQuery = gql`
  query GetVendorTeamMemberByEmail($email_id: String!) {
    getVendorTeamMember(email_id: $email_id) {
      id
    }
  }
`;

export const createVendor = gql`
  mutation createVendor($vendor: VendorInput) {
    createVendor(vendor: $vendor) {
      company_name
      id
    }
  }
`;

export const updateVendorPublic = gql`
  mutation updateVendorPublic($vendor: VendorUpdateInput) {
    updateVendorPublic(vendor: $vendor) {
      company_name
    }
  }
`;

export const BulkUpdateVendor = gql`
  mutation bulkUpdateVendor($input: BulkUpdateVendor) {
    bulkUpdateVendor(input: $input)
  }
`;

export const AddVendorTeamMember = gql`
  mutation addVendorTeamMember($input: VendorTeamMemberInput) {
    addVendorTeamMember(input: $input) {
      id
    }
  }
`;
export const EditVendorTeamMember = gql`
  mutation editVendorTeamMember($input: VendorTeamMemberInput) {
    editVendorTeamMember(input: $input) {
      id
    }
  }
`;

export const AddVendorLocations = gql`
  mutation addVendorLocations($input: VendorLocationInput) {
    addVendorLocations(input: $input) {
      id
    }
  }
`;
export const EditVendorLocations = gql`
  mutation editVendorLocations($input: VendorLocationInput) {
    editVendorLocations(input: $input) {
      id
    }
  }
`;
export const AddVendorPaymentInfo = gql`
  mutation addVendorPaymentInfo($input: VendorPaymentInformationInput) {
    addVendorPaymentInfo(input: $input) {
      id
    }
  }
`;
export const EditVendorPaymentInfo = gql`
  mutation editVendorPaymentInfo($input: VendorPaymentInformationInput) {
    editVendorPaymentInfo(input: $input) {
      id
    }
  }
`;
export const EditVendorJobCategories = gql`
  mutation editVendorJobCategories($input: VendorJobCategoriesInput) {
    editVendorJobCategories(input: $input) {
      id
    }
  }
`;

export const EditVendorType = gql`
  mutation editVendor($vendorId: ID!, $input: VendorEditInput!) {
    editVendor(vendorId: $vendorId, input: $input)
  }
`;

export const EditVendorProfileData = gql`
  mutation editVendorProfileData($input: VendorProfileDataInput) {
    editVendorProfileData(input: $input) {
      id
    }
  }
`;

export const AddVendorDocument = gql`
  mutation addVendorDocument($input: VendorDocumentAddInput) {
    addVendorDocument(input: $input) {
      id
    }
  }
`;

export const EditVendorDocument = gql`
  mutation editVendorDocument($id: ID!, $input: VendorDocumentDatesInput) {
    editVendorDocument(id: $id, input: $input) {
      id
    }
  }
`;

export const DeleteVendorDocument = gql`
  mutation deleteVendorDocument($input: [ID]) {
    deleteVendorDocument(input: $input)
  }
`;

export const GetCompanyTypes = gql`
  query getCompanyTypes {
    getCompanyTypes {
      id
      name
    }
  }
`;

export const GetCompanyTypesPublic = gql`
  query getCompanyTypesPublic($vendor_id: ID!, $verification_code: String) {
    getCompanyTypesPublic(vendor_id: $vendor_id, verification_code: $verification_code) {
      id
      name
    }
  }
`;

export const GetVendorExcludedHiringCompanies = gql`
  query getVendorExcludedHiringCompanies($vendorId: ID!) {
    getVendorExcludedHiringCompanies(vendor_id: $vendorId) {
      id
      name
      workspace {
        id
        name
      }
    }
  }
`;

export const CreateVendorExcludedHiringCompanies = gql`
  mutation createVendorExcludedHiringCompanies($vendorId: ID!, $hiringCompanyIds: [ID]) {
    createVendorExcludedHiringCompanies(vendor_id: $vendorId, hiring_company_ids: $hiringCompanyIds)
  }
`;

export const GetVendorSubscriptions = gql`
  query getVendorSubscriptions($vendorId: ID!) {
    getVendorSubscriptions(vendor_id: $vendorId) {
      id
      vendor_id
      name
      start_date
      end_date
      bill_frequency
      bill_amount
      client {
        id
        name
      }
    }
  }
`;

export const GetActiveVendorSubscription = gql`
  query getActiveVendorSubscription($vendorId: ID!) {
    getActiveVendorSubscription(vendor_id: $vendorId) {
      id
      vendor_id
      name
      start_date
      end_date
      bill_frequency
      bill_amount
      client {
        id
        name
      }
    }
  }
`;

export const AddVendorSubscription = gql`
  mutation addVendorSubscription($input: VendorSubscriptionInput) {
    addVendorSubscription(input: $input) {
      id
      vendor_id
      name
      start_date
      end_date
      bill_frequency
      bill_amount
      client {
        id
        name
      }
    }
  }
`;

export const EditVendorSubscription = gql`
  mutation editVendorSubscription($subscriptionId: ID!, $input: VendorSubscriptionUpdateInput) {
    editVendorSubscription(subscription_id: $subscriptionId, input: $input) {
      id
      vendor_id
      name
      start_date
      end_date
      bill_frequency
      bill_amount
      client {
        id
        name
      }
    }
  }
`;

export const DeleteVendorExcludedHiringCompanies = gql`
  mutation deleteVendorExcludedHiringCompanies($vendorId: ID!, $hiringCompanyIds: [ID]) {
    deleteVendorExcludedHiringCompanies(vendor_id: $vendorId, hiring_company_ids: $hiringCompanyIds)
  }
`;
